const angular = require('angular');
const app = angular.module('learn-directives');
/**
 * Defines the Normal Distribution Chart component
 * @argument {Application} Application injected to gain access to the global Application functions and properties
 */
app.directive('normalDistributionChart', [function () {
  return {
    restrict: 'E',
    scope: {
      data: '=',
      series: '='
    },
    template: require('../../../templates/directives/assessments/normal-distribution-chart.html'),
    controller: ['$scope', function ($scope) {
      var self = this;
      var chart = {
        options: {
          responsive: true,
          maintainAspectRatio: false,
          scaleShowVerticalLines: false,
          scaleLineColor: '#f7f7f7',
          scaleFontFamily: '"Gotham SSm A","Gotham SSm B",Helvetica,Arial,sans-serif',
          pointDotRadius : 0,
          pointDotStrokeWidth : 0,
          bezierCurve : false,
          showTooltips: false,
          scaleShowLabels: false
        },
        colorConfig: {
          baseColors: [],
          currColors: [],
          dimmedColor: {},
          defaultColors: [0,1,2,3]
        },
        getColor : function(color) {
          return {
            backgroundColor: color[0],
            borderColor: 'transparent',
            pointBackgroundColor: color[1],
            pointBorderColor: 'white',
            pointHoverBackgroundColor: color,
            pointHoverBorderColor: 'white'
          };
        }
      };

      chart.colorConfig.baseColors = [
        ['rgba(33,190,241,.35)', '#21bef1'],
        ['rgba(54,194,110,.6)', '#36c26e'],
        ['rgba(232,98,87,.5)', '#e86257'],
        ['rgba(253,129,38,.65)', '#fd8126'],
        ['rgba(147,149,151,.5)', '#c9cacb']
      ];
      chart.colorConfig.defaultColors = chart.colorConfig.defaultColors.map(function(idx) {
        return chart.getColor(chart.colorConfig.baseColors[idx]);
      });
      chart.colorConfig.dimmedColor = chart.getColor(chart.colorConfig.baseColors[4]);
      chart.colorConfig.currColors = chart.colorConfig.defaultColors;
      self.notEnoughVariance = false;
      self.initialize = function() {
        chart.colours = chart.colorConfig.defaultColors;

        var data = [];
        var labels = [];
        var labeled = false;
        if (!$scope.data || !$scope.data.length) {
          return;
        }
        self.notEnoughVariance = false;
        $scope.data.forEach(function(item, idx) {
          if (self.notEnoughVariance) {
            return;
          }
          if (!item.deviation || !item.mean) {
            self.notEnoughVariance = true;
            return;
          }
          var values = [];

          function NormalDensityZx(x, Mean, StdDev ) {
            if (!labeled) {
              labels.push(x)
            }
            var a = x - Mean;
            return Math.exp( -( a * a ) / ( 2 * StdDev * StdDev ) ) / ( Math.sqrt( 2 * Math.PI ) * StdDev );
          };

          for (var i = 0; i <= 100; i+=5) {
            if (item.mean && item.deviation) {
              values.push(NormalDensityZx(i, item.mean, item.deviation));
            }
          }

          if (labels.length) {
            labeled = true;
          }
          data.push(values);
        });
        if (self.notEnoughVariance) {
          return;
        }
        chart.labels = labels;
        chart.data = data;
        self.chart = chart;
      };

      if ($scope.data) {
        self.initialize();
      }

      $scope.$watch('data', function(newVal, oldVal) {
        if (newVal && newVal !== oldVal) {
          self.initialize();
        }
      }, true);

    }],
    controllerAs: 'norm'
  };
}]);
